import { render, staticRenderFns } from "./college.vue?vue&type=template&id=4fd8c8e6&scoped=true&"
import script from "./college.vue?vue&type=script&lang=js&"
export * from "./college.vue?vue&type=script&lang=js&"
import style0 from "./college.vue?vue&type=style&index=0&id=4fd8c8e6&scoped=true&lang=less&"
import style1 from "./college.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd8c8e6",
  null
  
)

export default component.exports